import applePay from 'braintree-web/apple-pay'
import client from 'braintree-web/client'

import mockedClient from './mockedClient'

const integrationObject = typeof window !== 'undefined' && window.app.envName === 'test'
  ? mockedClient
  : { client, applePay }

export default integrationObject
